let readyForCart = false;

// --- Patch fetch ---
const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const url = args[0];
  const response = await originalFetch.apply(this, args);
  const clone = response.clone();

  if (url.includes('cart.js') && readyForCart) {
    readyForCart = false; // reset so it only fires once per change.js
    clone.text().then(body => {
      try {
        const cartItems = JSON.parse(body)?.items;
        const nonUpsellProducts = cartItems.filter(item => !item.properties['__essential_upsell_funnel_id'])
        const upsellProducts = cartItems.filter(item => item.properties['__essential_upsell_funnel_id'])
        if (upsellProducts.length > 0 && nonUpsellProducts.length == 0) {
            theme.cartLoadingStarted()
            let updates = upsellProducts.reduce((acc, { id }) => (acc[id] = 0, acc), {});
            let xhr = new XMLHttpRequest();
            xhr.open('POST', window.Shopify.routes.root + 'cart/update.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) { // Done
                    if (xhr.status === 200) {
                        let response = JSON.parse(xhr.responseText);
                        theme.updateCartSummaries(false)
                        console.log('Success:', response);
                    } else {
                        console.error('Error:', xhr.status, xhr.statusText);
                    }
                }
            };
            xhr.send(JSON.stringify({ updates }));
            theme.cartLoadingFinished()
        }
      } catch (e) {
        console.warn('⚠️ Failed to parse cart.js:', e);
      }
    });
  }

  return response;
};

// --- Patch XMLHttpRequest ---
const originalXHROpen = XMLHttpRequest.prototype.open;
const originalXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._url = url;
  return originalXHROpen.call(this, method, url, ...rest);
};

XMLHttpRequest.prototype.send = function (...args) {
  const url = this._url;
  const xhr = this;

  if (url?.includes('change.js')) {
    xhr.addEventListener('load', () => {
      readyForCart = true;
      console.log('🔁 change.js detected via XHR — waiting for cart.js fetch');
    });
  }

  return originalXHRSend.apply(this, args);
};



